import React from 'react';

import { Button } from 'shared/components/ihcl/v2/button';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from 'shared/components/ihcl/v2/modal';

import { SmsOptInFinePrint } from './SmsOptInFinePrint';

type SmsOptInNudgeModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onTurnOnTextAlerts: () => void;
  onContinueWithoutTextAlerts: () => void;
};

export const SmsOptInNudgeModal = ({
  open,
  onOpenChange,
  onTurnOnTextAlerts,
  onContinueWithoutTextAlerts,
}: SmsOptInNudgeModalProps) => (
  <Modal open={open} onOpenChange={onOpenChange}>
    <ModalContent showCloseButton={false} className="text-center">
      <ModalHeader className="items-center">
        <ModalTitle className="mr-0">Turn on text alerts?</ModalTitle>
        <ModalDescription>
          Employers move quickly, and nurses with texts enabled hear about new
          matches and interview requests faster.
        </ModalDescription>
      </ModalHeader>
      <ModalBody className="gap-4">
        <Button
          color="alternate"
          size="lg"
          fullWidth
          onClick={onTurnOnTextAlerts}
          data-autofocus
          data-testid="sms-opt-in-nudge-turn-on"
        >
          Turn on text alerts
        </Button>
        <SmsOptInFinePrint variant="nudge" />
      </ModalBody>
      <ModalFooter className="justify-center">
        <Button
          variant="minimal"
          color="neutral"
          fullWidth
          onClick={onContinueWithoutTextAlerts}
          data-testid="sms-opt-in-nudge-continue"
        >
          Continue with email alerts only
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
